import { render, staticRenderFns } from "./RoundPause.vue?vue&type=template&id=4afc2188&scoped=true"
import script from "./RoundPause.vue?vue&type=script&lang=js"
export * from "./RoundPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc2188",
  null
  
)

export default component.exports